import { Component, OnInit } from "@angular/core";
import { ConfirmationService } from "primeng/api";
import { DynamicDialogConfig, DynamicDialogRef } from "primeng/dynamicdialog";
import { UserService } from "../../../../../shared";
import { DataService_ReminderAlertSetup } from "../../shared/data.service";
import { StationReminderAlertCopyRequest } from "../../shared/StationReminderAlertCopyRequest";
import * as moment from "moment";

@Component({
	selector: "app-scan-reminder-copy",
	templateUrl: "./scan-reminder-copy.component.html",
	styleUrls: ["./scan-reminder-copy.component.css"],
})
export class ScanReminderCopyComponent implements OnInit {
	constructor(
		private userService: UserService,
		private dialogConfig: DynamicDialogConfig,
		private ref: DynamicDialogRef,
		private confirmationService: ConfirmationService,
		private reminderService: DataService_ReminderAlertSetup
	) {}

	ngOnInit(): void {
		this.StationReminderAlert = this.dialogConfig.data.SelectedStationReminderAlert;

		this.selectedGroupValue = this.StationReminderAlert.SchoolID > 0 ? 2 : 1;

		this.Messagecolor = this.StationReminderAlert.MessageFontColor;
		this.Message = this.StationReminderAlert.Message;

		this.OriginalMessage = this.StationReminderAlert.Message;
		this.OriginalMessagecolor = this.StationReminderAlert.MessageFontColor;

		this.SelectedAlertTypeID = this.StationReminderAlert.AlertType;

		if (this.SelectedAlertTypeID == 2) {
			this.StartDate = new Date(this.StationReminderAlert.StartDate);
			this.EndDate = new Date(this.StationReminderAlert.EndDate);
		}

		this.Priority = this.StationReminderAlert.Priority;
		this.EntryMode = this.StationReminderAlert.EntryMode;
		this.ExitMode = this.StationReminderAlert.ExitMode;
		this.MealMode = this.StationReminderAlert.MealMode;
		this.AccessMode = this.StationReminderAlert.AccessMode;
		this.TimeStampMode = this.StationReminderAlert.TimeStampMode;
		this.EventEntryMode = this.StationReminderAlert.EventEntryMode;
		this.EventExitMode = this.StationReminderAlert.EventExitMode;

		this.ParentPortalSendNotification = this.StationReminderAlert.ParentPortalSendNotification;
		this.StudentPortalSendNotification = this.StationReminderAlert.StudentPortalSendNotification;
		this.StaffPortalSendNotification = this.StationReminderAlert.StaffPortalSendNotification;

		this.loadSound();
	}

	/////////////////////////////////////////////////////////////////////
	// Data
	/////////////////////////////////////////////////////////////////////

	StationReminderAlert: any; //Edit Mode

	selectedGroupValue: number = 2; //1 All Schools, 2 Selected School

	Messagecolor: any = "#000000";
	Message: string = "";

	OriginalMessage: string = "";
	OriginalMessagecolor: any = "#000000";

	SelectedSound: any;
	lstSoundItems: any = [];

	SelectedAlertTypeID: number = 1;
	lstAlertType: any = [
		{
			ID: 1,
			Desc: "Play Once",
		},
		{
			ID: 2,
			Desc: "Play Until Removed",
		},
		{
			ID: 3,
			Desc: "Play in Date Range",
		},
	];

	StartDate: Date = new Date();
	EndDate: Date = new Date();

	Priority: number = 2;
	lstPriority: any = [
		{
			ID: 1,
			Desc: "High",
		},
		{
			ID: 2,
			Desc: "Medium",
		},
		{
			ID: 3,
			Desc: "Low",
		},
	];

	EntryMode: boolean = true;
	ExitMode: boolean = true;
	MealMode: boolean = true;
	AccessMode: boolean = true;
	TimeStampMode: boolean = true;
	EventEntryMode: boolean = true;
	EventExitMode: boolean = true;

	ParentPortalSendNotification: boolean = true;
	StudentPortalSendNotification: boolean = true;
	StaffPortalSendNotification: boolean = true;

	loading: boolean = false;
	Processing: boolean = false;

	audio: any = new Audio();

	errorMessage: string = "";

	/////////////////////////////////////////////////////////////////////

	/////////////////////////////////////////////////////////////////////
	// Load Data
	/////////////////////////////////////////////////////////////////////

	loadSound() {
		this.loading = true;

		var result = this.reminderService.LoadSoundPopupList(this.StationReminderAlert.SchoolID);
		result.subscribe(
			(response) => {
				this.lstSoundItems = response;

				this.lstSoundItems.unshift({
					SoundLibraryID: -1,
					SoundFile: "None",
					SoundData: null,
				});

				this.SelectedSound = this.lstSoundItems[0];

				for (var z = 0; z < this.lstSoundItems.length; z++) {
					var next = this.lstSoundItems[z];

					if (next.SoundLibraryID == this.StationReminderAlert.SoundLibraryID) {
						this.SelectedSound = next;
						break;
					}
				}

				this.loading = false;
			},
			(error) => {
				this.loading = false;
			}
		);
	}

	/////////////////////////////////////////////////////////////////////

	/////////////////////////////////////////////////////////////////////
	// Buttons
	/////////////////////////////////////////////////////////////////////
	onAdd() {
		this.errorMessage = "";

		//
		// Error Handling
		//

		var fsDate: string = "";
		var feDate: string = "";

		if (this.SelectedAlertTypeID == 3) {
			fsDate = moment(this.StartDate).format("MM/DD/YYYY");
			feDate = moment(this.EndDate).format("MM/DD/YYYY");

			if (String(fsDate).toLowerCase().indexOf("invalid") != -1) {
				this.errorMessage = "Invalid Start Date";
				return;
			}
			if (String(feDate).toLowerCase().indexOf("invalid") != -1) {
				this.errorMessage = "Invalid End Date";
				return;
			}
		}

		//
		// Create Parms
		//

		this.Processing = true;

		var parms: StationReminderAlertCopyRequest = {
			Message: this.Message,
			AlertType: this.SelectedAlertTypeID,
			MessageFontColor: this.Messagecolor,
			SoundLibraryID: this.SelectedSound.SoundLibraryID,
			StartDate: fsDate,
			EndDate: feDate,
			Priority: this.Priority,
			EntryMode: this.EntryMode == true ? 1 : 0,
			ExitMode: this.ExitMode == true ? 1 : 0,
			MealMode: this.MealMode == true ? 1 : 0,
			AccessMode: this.AccessMode == true ? 1 : 0,
			TimeStampMode: this.TimeStampMode == true ? 1 : 0,
			EventEntryMode: this.EventEntryMode == true ? 1 : 0,
			EventExitMode: this.EventExitMode == true ? 1 : 0,
			ParentPortalSendNotification: this.ParentPortalSendNotification == true ? 1 : 0,
			StudentPortalSendNotification: this.StudentPortalSendNotification == true ? 1 : 0,
			StaffPortalSendNotification: this.StaffPortalSendNotification == true ? 1 : 0,
			OldStationReminderAlertID: this.StationReminderAlert.StationReminderAlertID,
		};

		var result = this.reminderService.StationReminderAlertCopy(parms);
		result.subscribe(
			(response: any) => {
				this.Processing = false;

				if (response.Status == true) {
					//Success Dialog
					this.confirmationService.confirm({
						key: "copy",
						acceptLabel: "Ok",
						rejectVisible: false,
						message: "Reminder Added Successfully",
						header: "Success",
						icon: "fa",
						accept: () => {
							this.ref.close(1);
						},
					});
				} else {
					//Fail Dialog
					this.confirmationService.confirm({
						key: "copy",
						acceptLabel: "Ok",
						rejectVisible: false,
						message: "Could Not create the Reminder",
						header: "ERROR",
						icon: "fa",
						accept: () => {},
					});
				}
			},
			(error) => {
				this.Processing = false;
			}
		);
	}

	onClose() {
		this.ref.close(0);
	}

	onPlay() {
		this.errorMessage = "";

		if (this.SelectedSound == null || this.SelectedSound.SoundData == null) {
			this.errorMessage = "Select a sound to play";
			return;
		}

		this.audio.src = this.SelectedSound.SoundData;
		this.audio.load();
		this.audio.play();
	}

	onStop() {
		this.errorMessage = "";

		if (this.audio.src != null && this.audio.currentTime > 0) {
			this.audio.pause();
			this.audio.currentTime = 0;
		}
	}
	/////////////////////////////////////////////////////////////////////

	/////////////////////////////////////////////////////////////////////
	//Events
	/////////////////////////////////////////////////////////////////////
	onSoundChange(val) {
		this.SelectedSound = val;

		this.onStop();
	}
	/////////////////////////////////////////////////////////////////////

	/////////////////////////////////////////////////////////////////////
	// Helpers
	/////////////////////////////////////////////////////////////////////
	IsLoading() {
		return this.loading == true || this.Processing == true;
	}
	/////////////////////////////////////////////////////////////////////
}
